import { List } from '@mairistem/composants';
import { ListeTable } from '@mairistem/liste';
import _ from 'lodash';
import React from 'react';

import type { PayeurType } from '@/types';
import { utils_string } from '@/utils';

interface PayeurListeTableRowProps {
  item: PayeurType;
  invalidate?: () => void;
  mode?: string;
}

const PayeurListeTableRow = (props: PayeurListeTableRowProps) => {
  const { item, invalidate, mode } = props;

  const { civilite, nom, prenom, adresse } = item || {};

  const {
    numeroVoirie,
    lettre,
    complementNumeroVoirie,
    numeroCodePostal,
    localite,
    libelleVoie,
    libellePays,
  } = adresse || {};

  const { libelle: libelleCivilite } = civilite || {};

  // Sert à redimensionner les lignes comme il faut quand on passe
  // de la grande liste à la liste dockée
  React.useEffect(() => {
    invalidate?.();
  }, [mode]);

  return (
    <ListeTable.Row>
      <ListeTable.Cell name="nom">
        {libelleCivilite || ''} {utils_string.toOfficialLastname(nom || '')}{' '}
        {utils_string.toOfficialFirstname(prenom || '')}
      </ListeTable.Cell>
      <ListeTable.Cell name="adresse">
        <List>
          <List.Description>
            {_.isNumber(numeroVoirie) && numeroVoirie !== 0 && `${numeroVoirie} `}
            {!_.isEmpty(lettre) && `${lettre} `}
            {!_.isEmpty(complementNumeroVoirie) && `${complementNumeroVoirie} `}
            {libelleVoie}
          </List.Description>
          <List.Description>
            {!_.isEmpty(numeroCodePostal) && `${numeroCodePostal} `}
            {!_.isEmpty(localite) && `${localite} `}
          </List.Description>
          <List.Description>{libellePays}</List.Description>
        </List>
      </ListeTable.Cell>
    </ListeTable.Row>
  );
};

export default PayeurListeTableRow;
